import React from 'react'

export const Dot = () => {
  return (
    <svg width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg" className='dot-icon'>
      <path d="M2.97011 2.952H0.0301094V0.0679998H2.97011V2.952Z" fill="#07091B" />
    </svg>
  )
}
